import { combineReducers } from 'redux';
import * as RequestStatus from 'ContentUtils/constants/RequestStatus';
import { CAN_SPAM_SETTINGS_FETCH, CAN_SPAM_SETTINGS_BY_ID_FETCH, UPDATE_CAN_SPAM_SETTINGS_PENDING, UPDATE_CAN_SPAM_SETTINGS_SUCCESS, UPDATE_CAN_SPAM_SETTINGS_FAIL } from 'ContentData/actions/ActionTypes';
const canSpamSettings = (state = {
  data: []
}, action) => {
  switch (action.type) {
    case CAN_SPAM_SETTINGS_FETCH:
      {
        const {
          response
        } = action;
        if (!response) return state;
        return Object.assign({}, state, {
          data: [...(state && state.data ? state.data : []), ...response.objects] || []
        });
      }
    case CAN_SPAM_SETTINGS_BY_ID_FETCH:
      {
        const {
          response
        } = action;
        if (!response) return state;
        return Object.assign({}, state, {
          data: response ? [...state.data, response] : state.data
        });
      }
    case UPDATE_CAN_SPAM_SETTINGS_SUCCESS:
      {
        const {
          id,
          data
        } = action;
        return Object.assign({}, state, {
          data: [...state.data.filter(f => f.id !== id), data]
        });
      }
    default:
      return state;
  }
};
const canSpamSettingsRequestStatus = (state = RequestStatus.UNINITIALIZED, action) => {
  switch (action.type) {
    case CAN_SPAM_SETTINGS_FETCH:
      {
        const {
          response,
          error
        } = action;
        if (response) return RequestStatus.SUCCEEDED;
        if (error) return RequestStatus.FAILED;
        return RequestStatus.PENDING;
      }
    default:
      return state;
  }
};
const canSpamSettingsByIdRequestStatus = (state = {}, action) => {
  switch (action.type) {
    case CAN_SPAM_SETTINGS_FETCH:
      {
        const {
          response
        } = action;
        if (response) {
          const ids = response.objects.reduce((acc, {
            id
          }) => Object.assign({}, acc, {
            [id]: RequestStatus.SUCCEEDED
          }), {});
          return Object.assign({}, state, ids);
        }
        return state;
      }
    case CAN_SPAM_SETTINGS_BY_ID_FETCH:
      {
        const {
          error,
          options,
          response
        } = action;
        if (response) {
          return Object.assign({}, state, {
            [options]: RequestStatus.SUCCEEDED
          });
        }
        if (error) return Object.assign({}, state, {
          [options]: RequestStatus.FAILED
        });
        return Object.assign({}, state, {
          [options]: RequestStatus.PENDING
        });
      }
    default:
      return state;
  }
};
const canSpamSettingsUpdateRequestStatus = (state = RequestStatus.UNINITIALIZED, action) => {
  switch (action.type) {
    case UPDATE_CAN_SPAM_SETTINGS_PENDING:
      {
        return RequestStatus.PENDING;
      }
    case UPDATE_CAN_SPAM_SETTINGS_SUCCESS:
      {
        return RequestStatus.SUCCEEDED;
      }
    case UPDATE_CAN_SPAM_SETTINGS_FAIL:
      {
        return RequestStatus.FAILED;
      }
    default:
      return state;
  }
};
export default combineReducers({
  canSpamSettings,
  requestStatus: canSpamSettingsRequestStatus,
  byIdRequestStatus: canSpamSettingsByIdRequestStatus,
  updateRequestStatus: canSpamSettingsUpdateRequestStatus
});